import css from 'styled-jsx/css';

export const ImageListingStyles = css`
  img {
    width: 100%;
    height: 100%;
  }
`;
